"use client";

import Image from "next/image";
import useUtility from "@/app/_hooks/useUtility";
import { useSection } from "./_hooks/useSection";
import TimelineSkeleton from "./_skeletons/TimelineSkeleton";
import { frontendImage } from "@/lib/helpers";

export const TimelineSection = () => {
  const { trans } = useUtility();
  const { content, elements, loading } = useSection("timeline");

  if (loading) {
    return <TimelineSkeleton />;
  }

  return (
    <section className="timeline-section section-bg py-100">
      <div className="container">
        <div className="row">
          {/* Left Content */}
          <div className="col-lg-5">
            <div className="timeline-content">
              <h5 className="timeline-content__title">
                {trans(content?.title)}
              </h5>
              <p className="timeline-content__desc">
                {trans(content?.description)}
              </p>
              <div className="timeline-content__thumb">
                <span className="shape-image">
                  <Image
                    src={frontendImage(content?.shape_one, "timeline")}
                    alt={trans("Shape One")}
                    width={292}
                    height={319}
                  />
                </span>
                <Image
                  src={frontendImage(content?.shape_two, "timeline")}
                  alt={trans("Shape Two")}
                  width={471}
                  height={583}
                />
              </div>
            </div>
          </div>

          {/* Right Timeline Items */}
          <div className="col-lg-7">
            {elements?.map((item, index) => (
              <div className="timeline-item" key={index}>
                <span className="timeline-item__year">{trans(item.year)}</span>
                <h6 className="timeline-item__title">{trans(item.title)}</h6>
                <p className="timeline-item__desc">{trans(item.description)}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
